import type {MemexColumnDataType, SystemColumnId} from '../../../api/columns/contracts/memex-column'
import {BaseColumnModel} from '../abstract/base'

export class CreatedColumnModel extends BaseColumnModel {
  declare readonly id: typeof SystemColumnId.Created
  declare readonly dataType: typeof MemexColumnDataType.Created
  declare readonly userDefined: false
}

export class UpdatedColumnModel extends BaseColumnModel {
  declare readonly id: typeof SystemColumnId.Updated
  declare readonly dataType: typeof MemexColumnDataType.Updated
  declare readonly userDefined: false
}

export class ClosedColumnModel extends BaseColumnModel {
  declare readonly id: typeof SystemColumnId.Closed
  declare readonly dataType: typeof MemexColumnDataType.Closed
  declare readonly userDefined: false
}
